module.exports = __webpack_public_path__ + "img/floor_f18_01.ce94be09.png";